import StepCard from "./components/StepCard";
import completeJobImg from "../../../assets/img/apponboarding/complete_job.svg";

const StepCompleteJob = ({ onCtaClick, onSkip, stepNumber, selectedOrganization }) => {
  const isOperation = selectedOrganization?.type === "operation";
  const ctaLabel = isOperation ? "View Tasks" : "View Jobs";
  console.log("completejob")
  return (
    <StepCard
      stepLabel={`Step ${stepNumber}`}
      title={`Complete Your First ${isOperation ? "Task" : "Job"}`}
      description={`Mark a ${isOperation ? "Task" : "Job"} as done and capture any notes, photos, or signatures needed.`}
      ctaLabel={ctaLabel}
      onCtaClick={onCtaClick}
      onSkip={onSkip}
      mediaSrc={null}
      selectedOrganization={selectedOrganization}
      backgroundColor="#FAF5F2"
      backgroundImage={completeJobImg}
      videoUrl="https://youtube.com/shorts/g2OeLV6Egf8"
    />
  );
};

export default StepCompleteJob;
